import React, {useState} from "react"

export function useKeyPress(targetKey: string, require_ctrl?: boolean, prevent_default?: boolean) {
    const [keyPressed, setKeyPressed] = useState<boolean>(false)

    function downHandler(event: KeyboardEvent) {
        if (event.code !== targetKey) {
            return
        }

        if (require_ctrl !== undefined) {
            if (require_ctrl && event.ctrlKey) {
                if (prevent_default !== undefined && prevent_default) { event.preventDefault() }
                setKeyPressed(true)
                return
            }

            if (!require_ctrl && !event.ctrlKey) {
                if (prevent_default !== undefined && prevent_default) { event.preventDefault() }
                setKeyPressed(true)
                return
            }
        } else {
            if (prevent_default !== undefined && prevent_default) { event.preventDefault() }
            setKeyPressed(true)
        }
    }

    function upHandler(event: KeyboardEvent) {
        if (event.code === targetKey) {
            setKeyPressed(false)
        }
    }

    React.useEffect(() => {
        window.addEventListener("keydown", downHandler)
        window.addEventListener("keyup", upHandler)

        return () => {
            window.removeEventListener("keydown", downHandler)
            window.removeEventListener("keyup", upHandler)
        }
    })

    return keyPressed
}
